<template>
  <div class="servicebox">
    <section id="banner">
      <div
        class="wrapper"
        :style="{background: 'url(' + categoryInfo.categoryPic + ') no-repeat center center'}"
      ></div>
    </section>
    <section id="breadcrumb">
      <div class="wrapper">
        <img src="../assets/breadcrumb.png" />
        <router-link :to="{path: '/'}">回首页</router-link>&nbsp;&gt;&nbsp;加入我们&nbsp;
      </div>
    </section>
    <section id="content">
      <div class="wrapper">
        <ul class="wrul">
          <li class="wrli" v-for="(item, index) in jobList" :key="index">
            <a>
              <h4>{{item.job}}</h4>
              <div>
                <a>{{item.salary}}</a>
                <p>
                  <span>武汉</span>
                  <span>{{item.createTime}}</span>
                </p>
              </div>
              <h5 class="mp">岗位职责：</h5>
              <p
                class="wrul_content"
                v-html="item.jobDuty"
              ></p>
              <h5>任职要求：</h5>
              <p
                class="wrul_content"
                v-html="item.jobRequirement"
              ></p>
              <h5>联系方式：</h5>
              <p
                class="wrul_content"
                v-html="item.contact"
              ></p>
            </a>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script type="text/ecmascript-6">
import { getCategoryInfo } from "@/api/content";
import { getJobList } from '@/api/joinus'
export default {
  name: "",
  data() {
    return {
      msg: "这是我的",
      categoryId: this.$route.query.categoryId,
      categoryInfo: {},
      jobList: []
    };
  },
  methods: {
    getBanner() {
      // console.log(this.categoryId)
      getCategoryInfo(this.categoryId).then((res) => {
        if (res.code !== 200) return;
        this.categoryInfo = res.data;
        this.categoryInfo.categoryPic =
          process.env.BASE_API + "/web" + this.categoryInfo.categoryPic;
      });
    },
    getJobData() {
      getJobList().then(res => {
        if (res.code !== 200) return
        this.jobList = res.data
        this.jobList.forEach(item => {
          item.jobDuty = item.jobDuty ? item.jobDuty.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' ').replace(' ', '&nbsp;') : '';
          item.jobRequirement = item.jobRequirement ? item.jobRequirement.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' ').replace(' ', '&nbsp;') : '';
          item.contact = item.contact ? item.contact.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' ').replace(' ', '&nbsp;') : '';
        })
      })
    }
  },
  mounted() {
    this.getBanner();
    this.getJobData()
  },
};
</script>

<style scoped >
#banner .wrapper {
  position: relative;
  width: 100%;
  height: 240px;
  box-sizing: border-box;
  background: url(../assets/20170519-17072284.jpg) center top no-repeat;
  background-size: 100% auto;
}
#banner .wrapper {
  background-size: auto 100% !important;
}
section .wrapper {
  width: 1280px;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
}
h5{
  margin: 16px 0 8px;
  font-size: 16px;
}
@media screen and (max-width: 760px) {
  section#banner .wrapper {
    height: 140px;
  }
}
@media screen and (max-width: 1300px) {
  section .wrapper {
    width: 100%;
  }
}
@media screen and (max-width: 1000px) {
  #banner .wrapper {
    background-size: auto 100%;
  }
}

section#breadcrumb {
  width: 100%;
  color: #fff;
  background: #c8c9cb;
}
@media screen and (max-width: 760px) {
  section#breadcrumb .wrapper {
    padding: 10px;
    font-size: 12px;
  }
}
#breadcrumb .wrapper {
  padding: 13px 40px;
  line-height: 16px;
  text-align: left;
  font-size: 14px;
  color: #333;
}
#breadcrumb .wrapper img {
  vertical-align: top;
  margin-right: 5px;
}
img {
  border: none;
  max-width: 100%;
  vertical-align: middle;
}
#breadcrumb .wrapper a {
  color: #333;
}
@media screen and (max-width: 1000px) {
  section#content .wrapper {
    width: 100%;
    /* padding: 40px 20px; */
  }
}
#content .wrapper {
  width: 1280px;
  padding: 40px 0;
  text-align: left;
  box-sizing: border-box;
}
@media screen and (max-width: 1300px) {
  .servicebox section .wrapper {
    width: 100%!important;
  }
}
#content .wrapper .wrul {
  width: 96%;
  margin: 0 auto;
}
#content .wrapper .wrul .wrli {
  position: relative;
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  padding: 20px 0;
}
@media screen and (max-width: 760px) {
  section#content .wrapper .wrul .wrli {
    padding: 12px 0;
  }
}
@media screen and (max-width: 760px) {
  section#content .wrapper .wrul .wrli h4 {
    font-size: 18px;
    line-height: 30px;
  }
}
@media screen and (max-width: 600px) {
  section#content .wrapper .wrul .wrli h4 {
   margin-bottom: 40px;
  }
}
#content .wrapper .wrul .wrli h4 {
  font-size: 27px;
  line-height: 60px;
  color: #333;
}
#content .wrapper .wrul .wrli div {
  position: absolute;
  top: 26px;
  right: 0;
  text-align: right;
}
@media screen and (max-width: 760px) {
  section#content .wrapper .wrul .wrli div {
  position: absolute;
  top: 15px;
  right: 0;
  text-align: right;
}
}
@media screen and (max-width: 600px) {
  section#content .wrapper .wrul .wrli div {
  position: absolute;
  top: 50px;
  left:0!important;
  text-align: left;
}
}
@media screen and (max-width: 760px) {
  section#content .wrapper .wrul .wrli div a {
    font-size: 16px;
  }
}
#content .wrapper .wrul .wrli div a {
  font-size: 20px;
  color: red;
}
#content .wrapper .wrul .wrli div p {
  margin-left: 10px;
  display: inline-block;
}
@media screen and (max-width: 760px) {
  section#content .wrapper .wrul .wrli div p span {
    padding: 0 4px;
    border-right: 1px solid #eee;
  }
}

#content .wrapper .wrul .wrli div p span {
  padding: 0 10px;
  border-right: 1px solid #eee;
}

#content .wrapper .wrul .wrli div p span:last-child {
  border: 0;
}

.wrul_content{
  color:#414141;
  /* text-indent: 2em; */
  /* margin: 20px; */
font-size: 16px;
line-height: 26px;
}
@media screen and (max-width: 760px) {
  section#content .wrapper .wrul .wrli .wrul_content{
      /* text-indent: 2em; */
font-size: 14px;
line-height: 20px;
margin-top: 5px;
}
}
</style>



// WEBPACK FOOTER //
// src/pages/joinus.vue